<div class="settings-box-shadow">
  <ng-template #sentenceRewritePopContent>
    While you type in supported editors, FlyMSG's AI silently scores your sentences and highlights
    ones that could read better — no manual trigger needed.
  </ng-template>
  <h3 class="no-left-margin" style="margin-bottom: 0">
    FlyMSG Sentence Rewriter
    <vng-icon
      name="info"
      class="info-icon"
      color="accent"
      [outline]="false"
      [ngbPopover]="sentenceRewritePopContent"
      [closeDelay]="5000"
      triggers="mouseenter:mouseleave"
      placement="top"
    ></vng-icon>
  </h3>
  <ng-container *ngIf="adminOverride">
    <em>This setting is controlled by your administrator.</em>
  </ng-container>
  <p style="margin-top: 1em">
    When enabled, sentences you type in supported editors are sent to FlyMSG's AI to be scored for
    rewrite suggestions, and highlights appear for sentences that can be improved. Nothing is sent
    while this is off — FlyMSG Sentence Rewriter is off by default.
  </p>

  <vng-card variant="ghost" padding="none" style="margin-top: 10px" [formGroup]="form">
    <vng-toggle color="accent" [disabled]="adminOverride" formControlName="sentenceRewrite" label="Enable"
      style="margin-bottom: 10px"></vng-toggle>

    <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px"
      class="settings-card-actions">
      <button
        type="button"
        [disabled]="adminOverride || !isDirty || isSaving"
        vng-button
        variant="primary"
        (click)="save()"
        tabindex="-1"
      >
        Save
      </button>
    </div>
  </vng-card>
</div>
